// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD9Q0azzA_wKwQ-QA9TtMrDoHnbmvTpt54',
    authDomain: 'vectornote-roadbook-web.firebaseapp.com',
    databaseURL: 'https://vectornote-roadbook-web.firebaseio.com',
    projectId: 'vectornote-roadbook-web',
    storageBucket: 'vectornote-roadbook-web.appspot.com',
    messagingSenderId: '270429185733',
    appId: '1:270429185733:web:3b4f2d80a2ca47c5',
    functions: 'https://us-central1-vectornote-roadbook-web.cloudfunctions.net/'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
